import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button as AntdButton, Dropdown } from 'antd';
import { useSelector } from 'react-redux';
import Logo from '../../assets/images/becomap.png';
import { EditorHeader, EditorHeaderItem, EditorHeaderSection, EditorTools } from '../../modules/editor/editor.style';
import Icon from '../common/Icon';
import { clearPersist, resetAllStates } from '../../store';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
const Header = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userDetails = useSelector((state) => state?.auth?.userDetails?.response?.data);
    const userName = useMemo(() => {
        if (!userDetails)
            return 'U';
        const text = userDetails?.firstName[0] + (userDetails?.lastName[0] || '');
        return text || 'U';
    }, [userDetails]);
    const profileItems = [
        {
            key: '1',
            label: userDetails?.email || 'User',
            icon: _jsx(Icon, { icon: "user-01", size: 16 }),
            disabled: true,
        },
        {
            type: 'divider',
        },
        {
            key: '4',
            label: 'Sign out',
            onClick: () => {
                clearPersist();
                resetAllStates(dispatch);
                navigate("/");
            },
            icon: _jsx(Icon, { icon: "log-out-02", size: 16 }),
        },
    ];
    return (_jsxs(EditorHeader, { children: [_jsx(EditorHeaderSection, { children: _jsx(EditorTools, { orientation: "horizontal", style: { outline: 'none' }, children: _jsx(EditorHeaderItem, { children: _jsx("img", { src: Logo, alt: "becomap", height: 22 }) }) }) }), _jsx(EditorHeaderSection, {}), _jsx(EditorHeaderSection, { children: _jsx(EditorHeaderItem, { hasBorder: true, style: { marginInline: '8px' }, children: _jsx(Dropdown, { trigger: ['click'], menu: {
                            items: profileItems,
                            selectable: true,
                        }, placement: "bottomRight", children: _jsx(AntdButton, { className: "sq", color: "default", variant: "text", children: userName }) }) }) })] }));
};
export default Header;
